import { Caption } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';
import NextLink from '~/client/shared/NextLink';
import Stack from '~/client/shared/Stack';
import CategoriesList from './CategoriesList';
import CategoriesListItem from './CategoriesListItem';
import Container from './Container';
import TableOfContents from '../TableOfContents';
import type TableOfContent from '../TableOfContents/@types/tableOfContent';

type Props = {
  tableOfContents: TableOfContent[];
};

const RightSideBar: FC<Props> = ({ tableOfContents }) => {
  const { siteConfig } = useSite();
  return (
    <Container>
      <Stack marginBottom={rem(40)}>
        <Caption color="trunks.100" as="p">
          <Translate id="blog.categories" />
        </Caption>
        <CategoriesList>
          {siteConfig.blogCategories.map((category) => (
            <CategoriesListItem key={category}>
              <NextLink href={`/blog/${category}`}>
                <Translate id={`blog.${category}`} />
              </NextLink>
            </CategoriesListItem>
          ))}
        </CategoriesList>
        {tableOfContents.length > 0 && (
          <TableOfContents tableOfContents={tableOfContents} />
        )}
      </Stack>
    </Container>
  );
};

export default RightSideBar;
